import {
    FETCH_SALES_OVERVIEW,
    GET_SALES_REPORT,
    REPORT_LOADING_STATE,
    SET_SALES_OVERVIEW_TYPE,
} from './reportsActionTypes';

const reportsInitialSate = {
    salesOverview: {},
    selectedValue: 'this_month',
    salesChartSummary: {
        total_sales: 0,
        total_orders: 0,
        total_earnings: 0,
        total_items: 0,
    },
    data: [],
    reportData: [],
    loading: false,
};

const reportsReducer = (state = reportsInitialSate, { type, payload }) => {
    switch (type) {
        // Get Order Summery
        case FETCH_SALES_OVERVIEW:
            return {
                ...state,
                salesOverview: payload,
            };
        case SET_SALES_OVERVIEW_TYPE:
            return {
                ...state,
                selectedValue: payload.value,
                salesChartSummary: payload.total,
                data: payload.data,
            };
        case REPORT_LOADING_STATE:
            return {
                ...state,
                loading: payload,
            };
        case GET_SALES_REPORT:
            return {
                ...state,
                reportData: payload,
            };
        default:
            return state;
    }
};

export default reportsReducer;
